(function (angular) {
    'use strict';

    angular.module('app')
        /**
         *
         */
        .run(['$timeout', '$rootScope', '$state', 'jwtService', 'apiSpacePicker', '$location', '$uibModal', '$uibModalStack', 'apiSpacesService', '$q', 'comapiChatService', 'permissionService',
            function ($timeout, $rootScope, $state, jwtService, apiSpacePicker, $location, $uibModal, $uibModalStack, apiSpacesService, $q, comapiChatService, permissionService) {

                $rootScope.$on("apiSpacesUpdate:picked", function (event, apiSpaceId) {

                    if (jwtService.payload && permissionService.checkPermission("chat:ro")) {
                        comapiChatService.initialise(apiSpaceId)
                            .then(result => {
                                return comapiChatService.getConversations("profile", "open");
                            })
                    }
                });

                $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
                    if (toState.name === 'totp') {
                        return;
                    }

                    if (toState.authenticate && !jwtService.isValid()) {
                        event.preventDefault();
                        // User isn’t authenticated
                        // $state.transitionTo("login");
                        if (!jwtService.payload || !jwtService.payload.sub) {
                            $state.go('login', { "link": $location.path() });
                        }
                        else {
                            var modal = $uibModal.open({
                                templateUrl: 'shared/login/relogin.html',
                                controller: 'ReLoginController',
                                size: 'sm',
                                backdrop: 'static',
                                keyboard: false
                            });
                            modal.result.then(function () {
                                $state.go(toState.name, toParams);
                            }, function () {
                                $state.go('login', { "link": $location.path() });
                            });
                        }
                    }
                    else if (!permissionService.checkPrivilegeToDisplay(toState.name)) {
                        $state.go('accessDenied');
                        event.preventDefault();
                    }

                    if (toParams.pickedApiSpaceId === null) {
                        event.preventDefault();
                        if (apiSpacePicker.getPicked()) {
                            toParams.pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;
                            $state.go(toState.name, toParams);
                        }
                        else {
                            var apiSpaces = apiSpacePicker.getApiSpaces();
                            if (apiSpaces && apiSpaces.length > 0) {
                                apiSpacePicker.setPicked(0);
                                toParams.pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;
                                $state.go(toState.name, toParams);
                            }
                            else {
                                apiSpacesService.getApiSpaces().then(function (response) {
                                    apiSpacePicker.updateApiSpaces(response);
                                    apiSpacePicker.setPicked(0);
                                    toParams.pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;
                                    $state.go(toState.name, toParams);
                                }).catch(function (error) {
                                    if (error.status < 500) {
                                        $state.go('home');
                                    } else {
                                        $state.go('error', { error: { toState: toState, toParams: toParams, fromState: fromState, fromParams: fromParams, error: error } });
                                    }
                                });
                            }
                        }
                    }
                });
                $rootScope.$on('$stateChangeSuccess', function () {
                    $uibModalStack.dismissAll();
                    document.body.scrollTop = 0;

                    //always scrolling to top of page
                    window.scrollTo(0, 0);
                });
                $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                    if (error.redirectTo) {
                        $state.go(error.redirectTo, error.redirectToParams);
                    }
                    else if (error.status >= 500) {
                        event.preventDefault();
                        $state.go('error', { error: { toState: toState, toParams: toParams, fromState: fromState, fromParams: fromParams, error: error } });
                    } else {
                        console.error("$stateChangeError", toState, toParams, fromState, fromParams, error);
                    }
                });
            }])
        /**
         *
         */
        .run(["$templateCache", function ($templateCache) {
            // Templates added as dynamic html
            $templateCache.put('uib/template/datepicker/day.html',
                "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\" class=\"dp-table dpt-day\"><thead><tr class=\"tr-dpnav\"><th><button type=\"button\" class=\"pull-left btn-dp\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"zmdi zmdi-long-arrow-left\"></i></button></th><th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" class=\"w-100 btn-dp\"><div class=\"dp-title\">{{title}}</div></button></th><th><button type=\"button\" class=\"pull-right btn-dp\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"zmdi zmdi-long-arrow-right\"></i></button></th></tr><tr class=\"tr-dpday\"><th ng-if=\"showWeeks\" class=\"text-center\"></th><th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\"><button type=\"button\" class=\"w-100 btn-dp btn-dpday btn-dpbody\" ng-class=\"{'dp-today': dt.current, 'dp-selected': dt.selected, 'dp-active': isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'dp-day-muted': dt.secondary, 'dp-day-today': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>"
            );


            $templateCache.put('uib/template/datepicker/month.html',
                "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\" class=\"dp-table\"><thead><tr class=\"tr-dpnav\"><th><button type=\"button\" class=\"pull-left btn-dp\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"zmdi zmdi-long-arrow-left\"></i></button></th><th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" class=\"w-100 btn-dp\"><div class=\"dp-title\">{{title}}</div></button></th><th><button type=\"button\" class=\"pull-right btn-dp\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"zmdi zmdi-long-arrow-right\"></i></button></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\"><button type=\"button\" class=\"w-100 btn-dp btn-dpbody\" ng-class=\"{'dp-selected': dt.selected, 'dp-active': isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'dp-day-today': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>"
            );

            $templateCache.put('uib/template/datepicker/popup.html',
                "<div><ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" ng-keydown=\"keydown($event)\"><li ng-transclude></li><li ng-if=\"showButtonBar\" class=\"dp-actions clearfix\"><button type=\"button\" class=\"btn btn-link\" ng-click=\"select('today', $event)\">{{ getText('current') }}</button> <button type=\"button\" class=\"btn btn-link\" ng-click=\"close($event)\">{{ getText('close') }}</button></li></ul></div>"
            );

            $templateCache.put('uib/template/datepicker/year.html',
                "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\" class=\"dp-table\"><thead><tr class=\"tr-dpnav\"><th><button type=\"button\" class=\"pull-left btn-dp\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"zmdi zmdi-long-arrow-left\"></i></button></th><th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"w-100 btn-dp\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><div class=\"dp-title\">{{title}}</div></button></th><th><button type=\"button\" class=\"pull-right btn-dp\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"zmdi zmdi-long-arrow-right\"></i></button></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\"><button type=\"button\" class=\"w-100 btn-dp btn-dpbody\" ng-class=\"{'dp-selected': dt.selected, 'dp-active': isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'dp-day-today': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>"
            );
        }])
        /**
         *
         */
        .config(['$provide', function ($provide) {
            $provide.decorator('$state', ['$delegate', '$rootScope', function ($delegate, $rootScope) {
                $rootScope.$on('$stateChangeStart', function (event, state, params) {
                    $delegate.next = state;
                    $delegate.toParams = params;
                });
                return $delegate;
            }]);
        }])
        /**
         *
         */
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.hashPrefix('');
        }])
        /**
        *
        */
        .config(['$qProvider', function ($qProvider) {
            $qProvider.errorOnUnhandledRejections(false);
        }])
        /**
         *
         */
        .config(['$uibModalProvider', function ($uibModalProvider) {
            $uibModalProvider.options = {
                backdrop: 'static'
            };
        }])
        /**
         *
         */
        .config(['$compileProvider', '$stateProvider', '$urlRouterProvider', '$httpProvider', function ($compileProvider, $stateProvider, $urlRouterProvider, $httpProvider) {

            // whitelist data uri's
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|data):/);

            // Http Intercpetor to check auth failures for xhr requests and also add auth header to all requests
            $httpProvider.interceptors.push('HttpInterceptor');
            $httpProvider.interceptors.push('CacheBusterInterceptor');

            $stateProvider.defaultSpecificState = function (params) {
                //name, url, template, controller, resolve
                if (!params.resolve) {
                    params.resolve = {};
                }
                return this.state(params.name, {
                    url: params.url,
                    templateUrl: params.template,
                    template: params.inlineTemplate,
                    controller: params.controller,
                    resolve: params.resolve,
                    authenticate: true,
                    params: params.params
                });
            };
            $stateProvider.state('accessDenied', {
                url: '/access-denied',
                views: {
                    'error': { templateUrl: 'shared/errorPages/customErrorView.html', controller: "CustomErrorCtrl" }
                }
            }).state('login', {
                url: '/login?user',
                views: {
                    'login': { templateUrl: 'shared/login/loginView.html', controller: 'LoginCtrl' }
                },
                params: {
                    link: null
                }
            }).state('totp', {
                url: '/totp',
                views: {
                    'login': { templateUrl: 'shared/login/totpView.html', controller: 'TOTPCtrl' }
                },
                params: {
                    accountId: null,
                    userId: null,
                    returnUrl: null
                }
            })
                .state('resetPassword', {
                    url: '/reset-password',
                    views: {
                        'login': { templateUrl: 'shared/login/resetPasswordView.html', controller: 'ResetPasswordCtrl' }
                    },
                }).state('register', {
                    url: '/register',
                    views: {
                        'login': {
                            templateUrl: 'shared/login/registrationView.html',
                            controller: 'RegisterCtrl'
                        }
                    },
                    onEnter: ['linkedinSDKService', function (linkedinSDKService) {
                        if (linkedinSDKService.init) {
                            linkedinSDKService.init();
                        }
                    }],
                    params: {
                        userData: null
                    }
                }).state('thanks', {
                    url: '/thank_you',
                    views: {
                        'thanks': {
                            templateUrl: 'shared/login/thankYouView.html',
                            controller: 'ThankYouCtrl'
                        }
                    },
                    onEnter: ['$window', 'linkedinSDKService', function ($window, linkedinSDKService) {
                        if ($window.google_trackConversion) {
                            $window.google_trackConversion({
                                google_conversion_id: 852602776,
                                google_conversion_label: 'q8JFCOGNvnEQmN_GlgM',
                                google_remarketing_only: false
                            });
                        }
                        if ($window.fbq) {
                            $window.fbq('track', 'PageView');
                        }
                        if (linkedinSDKService.init) {
                            linkedinSDKService.init();
                        }
                    }],
                    params: {
                        user: null,
                        pass: null
                    }
                }).state('emailvalidate', {
                    url: '/emailvalidation/{accountId}/completeverify',
                    views: {
                        'emailvalidate': {
                            templateUrl: 'shared/emailValidation/emailValidationView.html',
                            controller: 'emailValidationCtrl'
                        }
                    }
                }).state('error', {
                    url: '/error',
                    views: {
                        'error': { templateUrl: 'shared/errorPages/customErrorView.html', controller: 'CustomErrorCtrl' }
                    },
                    params: {
                        error: null
                    }
                })

                .state('controls', {
                    url: '/controls',
                    views: {
                        header: { templateUrl: 'shared/header/headerView.html', controller: 'HeaderCtrl' },
                        sidebar: { templateUrl: 'shared/controls/sidebarView.html', controller: 'dummySidebarController' },
                        content: { templateUrl: 'shared/controls/controlsView.html', controller: 'controlsCtrl' },
                        footer: { templateUrl: 'shared/footer/footerView.html', controller: 'FooterCtrl' }
                    },
                    authenticate: true
                })
                .state('main', {
                    url: '/',
                    views: {
                        header: { templateUrl: 'shared/header/headerView.html', controller: 'HeaderCtrl' },
                        sidebar: { templateUrl: 'shared/sidebar/sidebarView.html', controller: 'sidebarController' },
                        content: { template: '<ui-view/>' },
                        footer: { templateUrl: 'shared/footer/footerView.html', controller: 'FooterCtrl' }
                    },
                    authenticate: true,
                    resolve: {
                        apiSpaces: ['apiSpacePicker', function (apiSpacePicker) {
                            return apiSpacePicker.initialise();
                        }],
                        allowedChannels: ['customChannelService', '$q', (customChannelService, $q) => {
                            return customChannelService.getPossibleChannels().then((result) => result).catch((result) => {
                                return result.status < 500 ? $q.resolve(result) : $q.reject(result);
                            })
                        }]
                    }
                })
                .defaultSpecificState({
                    name: 'main.home',
                    url: 'home',
                    template: 'components/dashboard/templates/dashboardView.html',
                    controller: 'DashboardCtrl'
                })
                .state({
                    name: 'main.apiSpace',
                    url: 'apiSpaces/{pickedApiSpaceId}',
                    params: {
                        pickedApiSpaceId: null
                    },
                    templateUrl: 'components/templates/apiSpaceLanding.html',
                    resolve: {
                        globalUsers: ['$q', 'usersService', 'jwtService', function ($q, usersService, jwtService) {
                            return usersService.getUsers(jwtService.payload.accountId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        globalProfile: ['$q', 'myProfileService', 'jwtService', function ($q, myProfileService, jwtService) {
                            myProfileService.getMyProfile(jwtService.payload.accountId, jwtService.payload.userId).then(function (result) {
                                return result;
                            }).catch(function (result) {
                                var deferred = $q.defer();
                                if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                return deferred.promise;
                            });
                        }],
                        globalChannels: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {

                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                    }
                })

                /**
                 * Reports states
                 */
                .defaultSpecificState({
                    name: 'main.apiSpace.reports',
                    url: '/reports',
                    inlineTemplate: '<ui-view/>'
                })
                .state('main.apiSpace.reports.liveChat', {
                    url: '/liveChat',
                    templateUrl: 'components/reports/chat/templates/liveChatView.html',
                    controller: 'LiveChatCtrl',
                    authenticate: true
                })
                .state('main.apiSpace.reports.historicChat', {
                    url: '/historicChat',
                    templateUrl: 'components/reports/chat/templates/historicChatView.html',
                    controller: 'HistoricChatCtrl',
                    authenticate: true
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.reports.messagedata',
                    url: '/messagedata',
                    template: 'components/reports/branch/templates/messagedata.html',
                    controller: 'ReportsMessageDataCtrl',
                    resolve: {
                        // messageData: ['$q', '$stateParams', 'messageDataService', function ($q, $stateParams, messageDataService) {
                        //     return messageDataService.getQueriedMessageHistory($stateParams.pickedApiSpaceId)
                        //         .then(function (result) {
                        //             return result;
                        //         }).catch(function (result) {
                        //             var deferred = $q.defer();
                        //             if (result.status < 500) {
                        //                 deferred.resolve(result);
                        //             } else {
                        //                 deferred.reject(result);
                        //             }
                        //             return deferred.promise;
                        //         });
                        // }],
                        channelsData: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            return customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                            if (profileHelper.getSchema().length) {
                                return profileHelper.getSchema();
                            }
                            else {
                                return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return profileHelper.setSchema(result);
                                    }).catch(function (error) {
                                        return handleError($q, error);
                                    });
                            }
                        }]
                    }
                })
                .state('main.apiSpace.reports.messaging', {
                    url: '/messaging',
                    templateUrl: 'components/reports/channel/templates/channelsMain.html',
                    controller: 'ReportsMessagingCtrl',
                    resolve: {
                        channelsData: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            return customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    },
                    authenticate: true
                })

                .defaultSpecificState({
                    name: 'main.apiSpace.reports.messaging.channels',
                    url: '/channels',
                    template: 'components/reports/channel/templates/channels.html',
                    controller: 'ReportsChannelsCtrl',
                    resolve: {
                        channelsData: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            return customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                .state({
                    name: 'main.apiSpace.reports.messaging.channel',
                    url: '/:channel',
                    templateUrl: 'components/reports/channel/templates/singleChannel.html',
                    controller: 'SingleChannelCtrl',
                    resolve: {
                        channelsData: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            return customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        countries: ['$q', 'coreDataService', function ($q, coreDataService) {
                            return coreDataService.getCountries()
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    },
                    authenticate: true
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.reports.broadcast',
                    url: '/broadcast/:channelId',
                    template: 'components/reports/broadcast/tremplates/broadcastView.html',
                    controller: 'ReportsBroadcastCtrl',
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.reports.urlTracking',
                    url: '/url-tracking',
                    template: 'components/reports/tracking/templates/urlTrackingReportsView.html',
                    controller: 'UrlTrackingReportsCtrl',
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.reports.verify',
                    url: '/verify',
                    template: 'components/reports/verify/templates/verifyReportsView.html',
                    controller: 'VerifyReportsCtrl',
                })

                /**
                 * Branch states
                 */
                .defaultSpecificState({
                    name: 'main.apiSpace.branch',
                    url: '/branch',
                    template: 'components/toolkit/branch/templates/rules.html',
                    controller: 'RulesCtrl',
                    resolve: {
                        rulesData: ['$q', '$stateParams', 'rulesService', function ($q, $stateParams, rulesService) {
                            return rulesService.getRules($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        channelsData: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            return customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                /**
                 * Phone Validation states
                 */

                .defaultSpecificState({
                    name: 'main.apiSpace.phoneValidation',
                    url: '/phone-validation',
                    template: 'components/toolkit/phoneValidation/templates/phoneValidation.html',
                    controller: 'phoneValidationCtrl',
                    resolve: {
                        countries: ['$q', 'coreDataService', function ($q, coreDataService) {
                            return coreDataService.getCountries()
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                /**
                 * End of Toolkit States
                 */

                /**
                 * Channels states
                 */


                // !!! DO NOT REMOVE injection of the allowedChannels - it enforces allowedChannels resolve to be done before channels state starts it's own resolves

                .state('main.apiSpace.channels', {
                    url: '/channels',
                    templateUrl: 'components/channels/channelsConfiguration.html',
                    controller: 'channelsConfigurationCtrl',
                    resolve: {
                        emailSettings: ['$q', '$stateParams', 'emailSettingsService', 'permittedChannels', 'allowedChannels', function ($q, $stateParams, emailSettingsService, permittedChannels, allowedChannels) {
                            if (permittedChannels.canRead('email')) {
                                return emailSettingsService.getEmailSettings($stateParams.pickedApiSpaceId)
                                    .then(function (result) {

                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            } else {
                                return $q.resolve(false);
                            }
                        }],
                        fbData: ['$q', 'facebookService', '$stateParams', 'permittedChannels', 'allowedChannels', function ($q, facebookService, $stateParams, permittedChannels, allowedChannels) {
                            if (permittedChannels.canRead('fbMessenger')) {
                                return facebookService.getPageFromComapi($stateParams.pickedApiSpaceId)
                                    .then(function (response) {
                                        return response;
                                    })
                                    .catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            } else {
                                return $q.resolve(false);
                            }
                        }],
                        customChannelsData: ['$q', '$stateParams', 'customChannelService', 'permissionService', 'allowedChannels', function ($q, $stateParams, customChannelService, permissionService, allowedChannels) {
                            if (permissionService.checkPermission('chan:r')) {
                                return customChannelService.getCustomChannels($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    })
                                    .catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            } else {
                                return $q.resolve(false);
                            }

                        }],
                        twitterData: ['$q', 'twitterServices', '$stateParams', 'permittedChannels', 'allowedChannels', function ($q, twitterServices, $stateParams, permittedChannels, allowedChannels) {

                            if (permittedChannels.canRead('twitterDm')) {
                                return twitterServices.getTwitterDetails($stateParams.pickedApiSpaceId)
                                    .then(function (response) {
                                        return response;
                                    })
                                    .catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            } else {
                                return $q.resolve(false);
                            }

                        }],
                        whatsAppCloudData: ['$q', 'whatsAppServices', '$stateParams', 'permittedChannels', 'allowedChannels', function ($q, whatsAppServices, $stateParams, permittedChannels, allowedChannels) {
                            if (!permittedChannels.canRead('whatsApp')) {
                                return $q.resolve(false);
                            }

                            return whatsAppServices.getSuccessfulWhatsAppCloudConfigurations($stateParams.pickedApiSpaceId)
                                .then(function (response) {
                                    return response;
                                })
                                .catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve([]); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        whatsAppData: ['$q', 'whatsAppServices', '$stateParams', 'permittedChannels', 'allowedChannels', function ($q, whatsAppServices, $stateParams, permittedChannels, allowedChannels) {
                            if (permittedChannels.canRead('whatsApp')) {
                                return whatsAppServices.getAllWhatsAppConfigurations($stateParams.pickedApiSpaceId)
                                    .then(function (response) {
                                        return response;
                                    })
                                    .catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve([]); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            } else {
                                return $q.resolve([]);
                            }
                        }],
                        rcsData: ['$q', 'rcsServices', '$stateParams', 'permittedChannels', 'allowedChannels', function ($q, rcsServices, $stateParams, permittedChannels, allowedChannels) {
                            if (permittedChannels.canRead('rcs')) {
                                return rcsServices.getAllRcsConfigurations($stateParams.pickedApiSpaceId)
                                    .then(function (response) {
                                        return response;
                                    })
                                    .catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve([]); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            } else {
                                return $q.resolve([]);
                            }
                        }],

                    },
                    authenticate: true
                })


                /**
                 * Sms states
                 */


                // .defaultSpecificState({
                //     name: 'main.apiSpace.sms.tracking',
                //     url: '/tracking',
                //     template: 'components/channels/sms/templates/tracking.html',
                //     controller: 'trackingCtrl',
                //     resolve: {
                //         trackingData: ['$q', '$stateParams', 'trackingService', function ($q, $stateParams, trackingService) {
                //             return trackingService.getAllTrackingData($stateParams.pickedApiSpaceId)
                //                 .then(function (result) {
                //                     return result;
                //                 }).catch(function (result) {
                //                     var deferred = $q.defer();
                //                     if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                //                     return deferred.promise;
                //                 });
                //         }]
                //     }
                // })

                /**
                 * App Messaging states
                 */

                .state({
                    name: 'main.apiSpace.channels.push-apple',
                    url: '/push-apple',
                    templateUrl: 'components/channels/appMessaging/templates/APNSpush.html',
                    controller: 'PushCtrl',
                    resolve: {
                        pushData: ['$q', '$stateParams', 'pushService', function ($q, $stateParams, pushService) {
                            return pushService.getPushConfig($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    },
                    authenticate: true
                })
                .state({
                    name: 'main.apiSpace.channels.push-android',
                    url: '/push-android',
                    templateUrl: 'components/channels/appMessaging/templates/FCMpush.html',
                    controller: 'PushCtrl',
                    resolve: {
                        pushData: ['$q', '$stateParams', 'pushService', function ($q, $stateParams, pushService) {
                            return pushService.getPushConfig($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    },
                    authenticate: true
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.app-messaging.client-permissions',
                    url: '/client-permissions',
                    template: 'components/channels/appMessaging/templates/client-permissions.html',
                    controller: 'ClientPermissionsCtrl',
                    resolve: {
                        clientPermissionsData: function () {
                            return 0;
                        }
                    },
                    authenticate: true
                })


                /**
                 * End of Channels states
                 */



                /**
                 * Platform Configuration states
                 */
                /**
                 * ApiSpace Details states
                 */
                .defaultSpecificState({
                    name: 'main.apiSpace.details',
                    url: '/details',
                    template: 'components/platformConfiguration/apiSpaceDetails/templates/apiSpaceDetail.html',
                    controller: 'ApiSpaceCtrl',
                    resolve: {
                        apiSpaceData: ['$q', '$stateParams', 'apiSpacesService', function ($q, $stateParams, apiSpacesService) {
                            return apiSpacesService.getApiSpace($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                /**
                 * Data Preferences states
                 */

                .defaultSpecificState({
                    name: 'main.apiSpace.dataPreferences',
                    url: '/data-preferences',
                    template: 'components/platformConfiguration/dataPreferences/templates/dataPreferences.html',
                    controller: 'dataPreferencesController',
                    resolve: {
                        inboundData: ['inboundRulesData', 'permissionService', function (inboundRulesData, permissionService) {
                            if (permissionService.checkPermission("auto:optout:r")) {
                                return inboundRulesData.generateData().then(function () {
                                    return;
                                });
                            }
                            return;
                        }],
                        inboundOptOut: ['$q', 'inboundOptOutService', '$stateParams', 'permissionService', function ($q, inboundOptOutService, $stateParams, permissionService) {
                            if (permissionService.checkPermission("auto:optout:r")) {
                                return inboundOptOutService.getInboundOptOuts($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }
                            return;
                        }],
                        profilesOptIn: ['$q', 'profilesService', '$stateParams', 'permissionService', function ($q, profilesService, $stateParams, permissionService) {
                            if (permissionService.checkPermission("apis:ra")) {
                                return profilesService.getProfilesOptInConfig($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }
                            return;
                        }],
                        dataRetention: ['$q', 'dataPreferencesService', '$stateParams', 'permissionService', function ($q, dataPreferencesService, $stateParams, permissionService) {
                            if (permissionService.checkPermission("apis:ra")) {
                                return dataPreferencesService.getDataRetention($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }
                            return;
                        }],
                        possibleChannels: ['$q', 'customChannelService', '$stateParams', function ($q, customChannelService, $stateParams) {
                            return customChannelService.getPossibleChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                /**
                 * Integration states
                 */
                .state('main.apiSpace.integration', {
                    url: '/integration',
                    templateUrl: 'components/platformConfiguration/integration/templates/integration.html',
                    authenticate: true
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.integration.access-tokens',
                    url: '/access-tokens',
                    template: 'components/platformConfiguration/integration/templates/access-tokens.html',
                    controller: 'accessTokenCtrl',
                    resolve: {
                        accessTokenData: ['$q', '$stateParams', 'accessTokenService', function ($q, $stateParams, accessTokenService) {
                            return accessTokenService.getAccessTokens($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.integration.webhooks',
                    url: '/webhooks?showCoreDefault&allowDisable',
                    template: 'components/platformConfiguration/integration/templates/webhooks.html',
                    controller: 'webhooksCtrl',
                    resolve: {
                        useBatch: ['$q', 'featureService', function ($q, featureService) {
                            // "feature": "webhook-batched-events-enabled"
                            return featureService.isFeatureEnabledForAcount("webhook-batched-events-enabled")
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        canDisable: ['$q', 'featureService', function ($q, featureService) {
                            // "feature": "webhook-batched-events-enabled"
                            return featureService.isFeatureEnabledForAcount("webhooks-disable")
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        webhooksData: ['$q', '$stateParams', 'webhooksService', function ($q, $stateParams, webhooksService) {
                            return webhooksService.getWebhooks($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.integration.webhookFailures',
                    url: '/webhook-failures/:webhookId',
                    template: 'components/platformConfiguration/integration/templates/webhookFailures.html',
                    controller: 'webhookFailuresCtrl',
                    resolve: {
                        failureData: ['$q', '$stateParams', 'webhooksService', function ($q, $stateParams, webhooksService) {
                            return webhooksService.getWebhookFailures($stateParams.pickedApiSpaceId, $stateParams.webhookId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                /**
                 * End of Platform Configuration states
                 */

                /**
                 * non ApiSpace states
                 */
                .defaultSpecificState({
                    name: 'main.settings',
                    abstract: true,
                    url: 'settings',
                    inlineTemplate: '<ui-view/>'
                })
                .defaultSpecificState({
                    name: 'main.settings.my-profile',
                    url: '/my-profile',
                    template: 'components/settings/templates/my-profile.html',
                    controller: 'myProfileCtrl',
                    resolve: {
                        myProfileData: ['$q', 'myProfileService', 'jwtService', function ($q, myProfileService, jwtService) {
                            return myProfileService.getMyProfile(jwtService.payload.accountId, jwtService.payload.userId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })

                .defaultSpecificState({
                    name: 'main.settings.users',
                    url: '/users',
                    template: 'components/settings/templates/users.html',
                    controller: 'usersCtrl',
                    resolve: {
                        usersData: ['$q', 'usersService', 'jwtService', function ($q, usersService, jwtService) {
                            return usersService.getUsers(jwtService.payload.accountId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        roles: ['$q', 'usersService', 'jwtService', function ($q, usersService, jwtService) {
                            return usersService.getRoles()
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.templates',
                    url: '/templates',
                    template: 'components/messageTemplates/templates/templates.html',
                    controller: 'templatesCtrl',
                    resolve: {
                        profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                            if (profileHelper.getSchema().length) {
                                return profileHelper.getSchema();
                            }
                            else {
                                return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return profileHelper.setSchema(result);
                                    }).catch(function (error) {
                                        return handleError($q, error);
                                    });
                            }
                        }],
                        templatesData: ['$q', '$stateParams', 'templateService', function ($q, $stateParams, templateService) {
                            return templateService.getTemplates($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }]
                    }
                })
                .defaultSpecificState({
                    name: 'main.apiSpace.forms',
                    url: '/forms',
                    template: 'components/forms/templates/forms.html',
                    controller: 'FormsCtrl',
                    resolve: {
                        formsList: ['$q', '$stateParams', 'formService', function ($q, $stateParams, formService) {
                            return formService.getForms($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        formsTemplates: ['$q', '$stateParams', 'formService', function ($q, $stateParams, formService) {
                            return formService.getFormTemplates($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                        channels: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                            return customChannelService.getChannels($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (result) {
                                    var deferred = $q.defer();
                                    if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                    return deferred.promise;
                                });
                        }],
                    }
                });

            $urlRouterProvider.otherwise('/home', { templateUrl: "partials/home.html" });

        }]);

})(window.angular);
